// Modèles de courriers prêts à l'emploi (créés en brouillon, modifiables).
const p = (text) => ({ type: "paragraph", content: text ? [{ type: "text", text }] : [] });
const pb = (bold, rest) => ({
  type: "paragraph",
  content: [{ type: "text", text: bold, marks: [{ type: "bold" }] }, ...(rest ? [{ type: "text", text: rest }] : [])],
});
const li = (text) => ({ type: "listItem", content: [p(text)] });

const INVENDUS_DLC_PARAS = [
  "Madame, Monsieur,",
  "Nous vous remercions pour la confiance que vous accordez à Maison Thaï. Par la présente, nous souhaitons rappeler le cadre applicable aux produits invendus dont la date limite de consommation (DLC) est dépassée.",
];

export const LETTER_TEMPLATES = [
  {
    key: "invendus-dlc",
    label: "Invendus DLC — responsabilités du revendeur",
    letter_type: "Information",
    subject: "Gestion des invendus après la date limite de consommation (DLC)",
    body_json: {
      type: "doc",
      content: [
        ...INVENDUS_DLC_PARAS.map(p),
        pb("Cadre légal. ", "Conformément à l'ordonnance du DFI concernant l'information sur les denrées alimentaires (OIDAl, RS 817.022.16), une denrée dont la DLC est dépassée ne peut plus être remise, ni vendue ni donnée. Nos plats contenant des ingrédients d'origine animale relèvent en outre, une fois retirés de la vente, de l'ordonnance concernant les sous-produits animaux (OSPA) et doivent être éliminés par une filière autorisée."),
        pb("Responsabilité du revendeur. ", "À compter de la livraison, la marchandise est placée sous votre responsabilité, y compris le respect de la chaîne du froid, la rotation des stocks et le retrait de la vente au plus tard à la DLC. Il vous appartient :"),
        {
          type: "bulletList",
          content: [
            li("de retirer de la vente les produits arrivant à leur DLC ;"),
            li("de les éliminer par une filière autorisée (méthanisation, incinération ou prestataire agréé) ;"),
            li("de documenter ces retraits et éliminations dans votre autocontrôle (HACCP)."),
          ],
        },
        pb("Reprises et avoirs. ", "Maison Thaï ne reprend pas les produits invendus et n'émet pas d'avoir pour un dépassement de DLC. Toute exception éventuelle est accordée à titre purement commercial, ponctuellement, et ne constitue ni un précédent ni un engagement pour l'avenir."),
        p("Nous restons volontiers à votre disposition pour ajuster les quantités livrées à votre rythme de vente, afin de limiter les invendus."),
      ],
    },
  },
];

const plain = (node) => (node.text || "") + (node.content || []).map(plain).join(node.type === "doc" ? "\n" : "");

export const templatePayload = (tpl) => ({
  letter_type: tpl.letter_type,
  subject: tpl.subject,
  body_json: tpl.body_json,
  body_plain: plain(tpl.body_json),
});
